import React, {useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { getPerformaInvoices } from '../../redux/actions/performaInvoiceAction'
import moment from 'moment/moment'
import Loader from '../../utility/Loader'
import SearchBox from '../../components/utility/SearchBox'
import {copyIcon, editIcon, deleteIcon, convertedToBill, convertToBill} from '../../utility/svg'
import Tooltip from '@mui/material/Tooltip';
import DeleteHandler from '../../components/BillingSystem/DeleteHandler'
import DuplicateHandler from '../../components/BillingSystem/DuplicateHandler'
import ConvertHandler from '../../components/BillingSystem/ConvertHandler'

const PerformaInvoices = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {performaInvoices, loading, totalCount, loadingMore} = useSelector(state=>state.performaInvoices)
    const [selectedPerformaInvoiceId, setSelectedPerformaInvoiceId] = useState()
    const [keyword, setKeyword] = useState("")
    const [page, setPage] = useState(1)

    useEffect(() => {
        if (performaInvoices.length === 0) {
            dispatch(getPerformaInvoices("", 1))
        }
        setPage(1)
    }, [dispatch, performaInvoices.length])

    const filteredInvoices = performaInvoices.filter(item => {
        const regex = new RegExp(keyword, 'i');
        return regex.test(item.billTo.name);
    });

    const handleSearch = (term) => {
        setKeyword(term)
    }

    const loadMore = React.useCallback(() => {
        if (performaInvoices.length < totalCount && !loadingMore && keyword === "") {
            const nextPage = page + 1
            dispatch(getPerformaInvoices("", nextPage, true))
            setPage(nextPage)
        }
    }, [performaInvoices.length, totalCount, loadingMore, keyword, page, dispatch])

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMore()
            }
        }, { threshold: 1.0 })

        const target = document.querySelector('#load-more-trigger')
        if (target) observer.observe(target)

        return () => {
            if (target) observer.unobserve(target)
        }
    }, [loadMore])

  const handleConvert = (id) => {
    setSelectedPerformaInvoiceId(id)
    document.getElementById("openConvertHandlerModal").click()
  }

  const handleDuplicate = (id) => {
    setSelectedPerformaInvoiceId(id)
    document.getElementById("openDuplicateHandlerModal").click()
  }

  const handleDelete = (id) => {
    setSelectedPerformaInvoiceId(id)
    document.getElementById("openDeleteHandlerModal").click()
  }

  const navigateToViewPerformaInvoice = (id) => (
    navigate(`/performaInvoice/print/${id}`)
  )

  return loading ? (<Loader/>) : (
    <section className='py-5 min-vh-100'>
      <div className="container">
        <div className="row">
          <div className="col-6 flex-center"><Link to={'/'} className='h2 text-primary text-center fw-bold text-underline'>Performa <span className='d-none d-lg-inline'>Invoice</span></Link></div>
          <div className="col-6 flex-center"><Link to={'/bills'} className='h2 text-primary text-center fw-bold underline opacity-50'>Tax Invoice</Link></div>
        </div>
      </div>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <Link className='btn btn-tertiary mt-4' to={'/performaInvoice/new'}>Create New PI</Link>
          <SearchBox onSearch={handleSearch} placeholder="Search by Client Name..." />
        </div>
        {filteredInvoices && filteredInvoices.map((item, index) => (
            <div key={index}
              className="d-flex flex-column flex-lg-row align-items-start justify-content-start align-items-lg-center justify-content-lg-between flex-wrap py-3 gap-3">
              <div className="flex-grow-1 w-100 w-lg-auto">
                <div onClick={()=>navigateToViewPerformaInvoice(item._id)} className={`cursor-pointer transition-hover shadow d-flex flex-wrap align-items-start justify-content-between text-white p-3 rounded-2 fw-regular ${index%2===0 ? 'bg-primary' : 'bg-primary-2'}`}>
                  <div className='d-flex flex-column flex-lg-row'>
                    <div className="me-2">{`PI-${item.taxYear}-${item.invoiceNumber}`}</div>
                    <div className="fw-bold">{item.billTo.name}</div>
                  </div>
                  <div>
                    {moment(item.createdAt).format('D MMM YY')}
                  </div>
                </div>
              </div>
              <div className='flex-center h-100'>
                {/* <span className='shadow me-3 cursor-pointer transition-hover'>{item.invoiceStatus === "converted" ? convertedIcon : notConvertedIcon}</span>
                <span className='shadow me-3 cursor-pointer transition-hover' onClick={()=>handleDuplicate(item._id)}>{copyIcon}</span>
                <Link className='shadow me-3 cursor-pointer transition-hover' to={`/performaInvoice/${item._id}`}>{editIcon}</Link>
                <span className='shadow cursor-pointer transition-hover' onClick={()=>handleDelete(item._id)}>{deleteIcon}</span> */}

                <Tooltip title="Convert To Bill" placement="top"><span className='shadow me-3 cursor-pointer transition-hover' onClick={()=>handleConvert(item._id)}>{item.invoiceStatus === "converted" ? convertedToBill : convertToBill}</span></Tooltip>
                <Tooltip title="Duplicate PI" placement="top"><span className='shadow me-3 cursor-pointer transition-hover' onClick={()=>handleDuplicate(item._id)}>{copyIcon}</span></Tooltip>
                <Tooltip title="Edit PI" placement="top"><Link className='shadow me-3 cursor-pointer transition-hover' to={`/performaInvoice/${item._id}`}>{editIcon}</Link></Tooltip>
                <Tooltip title="Delete PI" placement="top"><span className='shadow cursor-pointer transition-hover' onClick={()=>handleDelete(item._id)}>{deleteIcon}</span></Tooltip>

                <DeleteHandler type={"performaInvoice"} id={selectedPerformaInvoiceId} />
                <button className='btn btn-primary d-none' data-bs-toggle="modal" data-bs-target="#deleteHandler" id='openDeleteHandlerModal'>Delete Handler</button>
                <DuplicateHandler type={"performaInvoice"} id={selectedPerformaInvoiceId} />
                <button className='btn btn-primary d-none' data-bs-toggle="modal" data-bs-target="#duplicateHandler" id='openDuplicateHandlerModal'>Duplicate Handler</button>
                <ConvertHandler type={"performaInvoice"} id={selectedPerformaInvoiceId} />
                <button className='btn btn-primary d-none' data-bs-toggle="modal" data-bs-target="#convertHandler" id='openConvertHandlerModal'>Convert Handler</button>
              </div>
            </div>
        ))}
        
        {performaInvoices.length < totalCount && (
            <div id="load-more-trigger" className="text-center py-4">
                {loadingMore ? (
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading more...</span>
                    </div>
                ) : (
                    <span className="text-muted small">Scroll down to load more</span>
                )}
            </div>
        )}
      </div>

    </section>
  )
}

export default PerformaInvoices